export default __webpack_public_path__ + "static/media/3.f6d99fb3.png";